import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './vuetify'
import './vuesax'
import './buefy'
import './vue-multiselect'
import './element'
import './devextreme'
import fontawesome from '@fortawesome/fontawesome'
import freeSolid from '@fortawesome/fontawesome-free-solid'
import brands from '@fortawesome/fontawesome-free-brands'
import regular, { faHeart } from '@fortawesome/fontawesome-free-regular'

// Jquery
window.$ = window.jQuery = require('jquery')

fontawesome.library.add(freeSolid)
fontawesome.library.add(brands)
fontawesome.library.add(regular)
fontawesome.library.add(faHeart)
